export default __webpack_public_path__ + "static/media/electronicSigniturePad.247f2c58.svg";